import { render, staticRenderFns } from "./SendCode.vue?vue&type=template&id=552458bc&scoped=true&"
import script from "./SendCode.vue?vue&type=script&lang=js&"
export * from "./SendCode.vue?vue&type=script&lang=js&"
import style0 from "./SendCode.vue?vue&type=style&index=0&id=552458bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552458bc",
  null
  
)

export default component.exports